export default __webpack_public_path__ + "static/media/trackinfo_kart.05e849be.png";